import React, { useEffect, useState } from "react";
import { LeaveEditPageModal } from "./leave_edit_page_modal";
import {
  hasPendingLeaveConfirmation,
  resolveLeaveConfirmation,
  subscribeToLeaveConfirmation,
} from "../lib/leave_confirm_store";

export function LeaveConfirmProvider() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeToLeaveConfirmation(() => {
      setShowModal(hasPendingLeaveConfirmation());
    });
    return unsubscribe;
  }, []);

  const handleCancel = () => resolveLeaveConfirmation(false);
  const handleDiscard = () => resolveLeaveConfirmation(true);

  return (
    <LeaveEditPageModal
      show={showModal}
      onCancel={handleCancel}
      onDiscard={handleDiscard}
    />
  );
}
